<template>
  <Link :href="'/themenbezogenes-lernen/' + category.id + params" class="lg:min-h-[150px] card--img hover:bg-primary-500 hover:text-white group">
    <div class="p-4 md:p-6">
      <h2 class="text-sm lg:text-lg break-words text-primary-500 group-hover:text-white font-bold mb-2">{{ category.name }}</h2>
      <table class="table-fixed w-full text-sm md:text-base">
        <tr>
          <td class="pb-2 ">Anzahl der Fragen:</td>
          <td class="pb-2  text-right" >{{ category.unique_questions_count }}</td>
        </tr>
        <tr>
          <td class="pb-2 ">Bereits geübt:</td>
          <td class="pb-2  text-right"> {{ category.practiced }}</td>
        </tr>
        <tr>
          <td class="pb-2 ">Aktuelle Fehler:</td>
          <td class="pb-2  text-right group-hover:text-white" :class="recommendationClass"> {{ category.mistakes }}</td>
        </tr>
        <tr>
          <td class="pb-2 align-top">Empfehlung:</td>
          <td class="pb-2  text-right group-hover:text-white" :class="recommendationClass"> {{ __('mistakes.recommendation.' + recommendation ) }}</td>
        </tr>
      </table>
    </div>
  </Link>
</template>

<script>
import {Link} from '@inertiajs/inertia-vue3'

export default {
  name: 'CategoryItem',

  components: {
    Link,
  },

  props: {
    category: {
      type: Object,
      required: true,
    },
    params: {
      type: String,
      required: false,
    },
  },

  computed: {
    recommendationClass() {
      if( this.recommendation > 2 ) {
        return 'text-success-500'
      }  else if( this.recommendation === 2 ) {
        return 'text-orange-500'
      } else {
        return 'text-red-500'
      }
    },

    recommendation() {
      if( this.category.practiced >= this.category.unique_questions_count && this.category.mistakes === 0 ) {
        return 4
      } else if( this.category.practiced < ( this.category.unique_questions_count / 2 ) ) {
        return 2
      } else if( this.category.mistakes > 2 ) {
        return 1
      } else {
        return 3
      }
    },
  }
}
</script>

<style scoped>

</style>